function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Button, Popover, TextButton, useOverlayContext } from 'seagull';
import { AddCircleLiner24 } from 'seagull/icons';
import ServicePicker from "../ServiceCreation/ServicePicker/ServicePicker";
import { useActiveServiceTemplates } from "../../hooks/reactQuery/queries/useActiveServiceTemplates";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { AddServicesPopover } from "./AddServicesPopover/AddServicesPopover";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function AddServicesButton(props) {
  const {
    className,
    agreementData,
    disabled,
    testId = '',
    text = 'Add services',
    variant = 'button',
    popoverHorizontalAlign = 'center',
    onClick,
    onServicesAdded
  } = props;
  useActiveServiceTemplates({
    refreshOnMount: true
  });
  const {
    showModal
  } = useOverlayContext();
  const {
    ADD_SERVICES_AUTOCOMPLETE
  } = useFeatureFlags();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = !!anchorEl;
  async function addServices(event) {
    onClick === null || onClick === void 0 || onClick();
    if (ADD_SERVICES_AUTOCOMPLETE) {
      setAnchorEl(event.currentTarget);
    } else {
      const newServices = await showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: p => /*#__PURE__*/_jsx(ServicePicker, _objectSpread({
          agreementData: agreementData
        }, p))
      });
      if (!newServices || newServices.length === 0) return;
      onServicesAdded(newServices);
    }
  }
  function handleClose() {
    setAnchorEl(null);
  }
  function renderButton() {
    switch (variant) {
      case 'button':
        return /*#__PURE__*/_jsx(Button, {
          type: "button",
          disabled: disabled,
          "data-testid": testId,
          className: className,
          onClick: addServices,
          children: text
        });
      case 'textWithIcon':
        return /*#__PURE__*/_jsx(TextButton, {
          type: "button",
          className: className,
          disabled: disabled,
          underline: "none",
          weight: "normal",
          "data-testid": testId,
          prefixIcon: /*#__PURE__*/_jsx(AddCircleLiner24, {}),
          onClick: addServices,
          children: text
        });
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderButton(), ADD_SERVICES_AUTOCOMPLETE && /*#__PURE__*/_jsx(Popover, {
      anchorEl: anchorEl,
      open: isOpen,
      anchorOrigin: {
        vertical: -8,
        horizontal: popoverHorizontalAlign
      },
      transformOrigin: {
        vertical: 'bottom',
        horizontal: popoverHorizontalAlign
      },
      onClose: handleClose,
      children: /*#__PURE__*/_jsx(AddServicesPopover, {
        testId: testId,
        agreementData: agreementData,
        onSelectServiceTemplate: service => {
          handleClose();
          onServicesAdded([service]);
        }
      })
    })]
  });
}